import { render, staticRenderFns } from "./UserProfileDeleteProgressConfirmDialog.vue?vue&type=template&id=5b038aa5&"
import script from "./UserProfileDeleteProgressConfirmDialog.vue?vue&type=script&lang=ts&"
export * from "./UserProfileDeleteProgressConfirmDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports